module.exports = __webpack_public_path__ + "static/img/31-Guild-Living-urban-retirement-communities.3aa1522e.jpg";